import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/report-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-587f409e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "detail-page-header"
}
const _hoisted_2 = { class: "header xa-flex" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "info" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "极飞科技-技术支持", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-title" }, "飞行日志分析报告", -1))
const _hoisted_7 = { class: "cotnent-list" }
const _hoisted_8 = { class: "list-title" }
const _hoisted_9 = {
  key: 0,
  class: "list-info"
}
const _hoisted_10 = { class: "info-label" }
const _hoisted_11 = { class: "info-content" }
const _hoisted_12 = {
  key: 1,
  class: "list-text"
}
const _hoisted_13 = {
  key: 2,
  class: "image-list"
}
const _hoisted_14 = ["src", "onClick"]

import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { ImageInfo } from '@/types/public'
import { ImagePreview, Toast } from 'vant'
import { GetImagesInfo } from '@/apis/public'
import { reactive, computed, ref, Ref } from 'vue'
import { commonErrorHandle } from '@/utils/error-handle'
import { useEmFontSize } from '@/compositions/fault/report'
import { GetRepairOrderAnalysisReport } from '@/apis/malfunction-repair'
import { GetRepairOrderAnalysisReportResult } from '@/types/malfunction-repair'
import dayjs from 'dayjs'
import AppHeader from '@/components/Header.vue'

interface CommonStringObject {
  noPddingRight?: boolean
  label: string
  value: string
}
interface FaultInfoListItem {
  title: string
  type: string
  infoList?: CommonStringObject[]
  text?: string
  imgList?: string[]
}
interface CheckImageFunc {
  (url: string, urls: string[]): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'report',
  setup(__props) {

const guid = useRoute().query.guid as string
const store = useStore() // vuestore
const isFromFuwu = (useRoute().query.from as string) === 'fuwu'
const pagePaddingTop = computed(() => store.getters.pagePaddingTop)
let list: Array<FaultInfoListItem> = []
let imgs: string[] = []
const createAt: Ref<string> = ref('')
const data = reactive({
  list,
  imgs,
})
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const components = {
  AppHeader,
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const emFt = useEmFontSize()
async function getPageDetail() {
  Toast.loading({
    message: '加载中...',
    forbidClick: true,
    loadingType: 'spinner',
    duration: 0,
  })
  try {
    let data = await GetRepairOrderAnalysisReport(guid)
    const analysisImages = data.responsible_work_order.responsible_analysis.images
    let imgData: ImageInfo[] = analysisImages.length
      ? await GetImagesInfo({ res_uids: analysisImages, width: 500, height: 500 })
      : []
    console.log('data', data, imgData)
    initPageDetail(data, imgData)
    Toast.clear()
  } catch (error) {
    commonErrorHandle(error)
  }
}
function initPageDetail(detail: GetRepairOrderAnalysisReportResult, imgs: ImageInfo[]) {
  const service = detail.after_sales_service
  const responsible_work_order = detail.responsible_work_order
  const analysis = responsible_work_order?.responsible_analysis

  createAt.value = service.created_at ? service.created_at.split(' ')[0] : ''
  data.list = [
    {
      title: '基本信息',
      type: 'list',
      infoList: [
        { label: '序列号', value: service.serial_number },
        { label: '机型', value: service.eq_model },
        { label: '服务单号', value: service.service_no },
        {
          label: '激活时间',
          value: dayjs(service.activate_at * 1000).format('YYYY-MM-DD HH:mm:ss'),
          noPddingRight: true,
        },
      ],
    },
    {
      title: '故障分析信息',
      type: 'list',
      infoList: [
        {
          label: '故障架次',
          value: analysis?.accident_sortie || analysis?.logs_sortie.join(','),
        },
        {
          label: '故障现象',
          value: analysis.accident_phenomenon ? analysis.accident_phenomenon.join(',') : '',
        },
        {
          label: '责任判断',
          // value: `${responsible_work_order.analysis_damage_type_text}/${responsible_work_order.analysis_responsibility_type_text}`,
          value: responsible_work_order.work_order_result_text,
        },
        { label: '是否炸机', value: responsible_work_order.analysis_is_plane_crash_text },
        {
          label: '故障类型',
          value: analysis.fault_type ? analysis.fault_type.pop() : '',
        },
      ],
    },
    {
      title: '飞行日志综合分析', // description
      type: 'text',
      text: analysis.description,
    },
    {
      title: '故障检查或维修建议', // suggest
      type: 'text',
      text: analysis.suggest,
    },
    {
      title: '附图（点击查看原图）',
      type: 'img',
      imgList: imgs.map((imageItem) => imageItem.url),
    },
  ]
}
let checkImage: CheckImageFunc = function (url: string, urls: string[]) {
  let startPosition = 0
  urls.forEach((item, index) => {
    if (url === item) {
      startPosition = index
    }
  })
  ImagePreview({
    images: [url],
    closeable: true,
    startPosition,
  })
}

getPageDetail()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "report-page",
    style: _normalizeStyle({ 'padding-top': `${Number(_unref(pagePaddingTop))}px` })
  }, [
    (!isFromFuwu)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(AppHeader, { title: "分析报告" })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", {
      class: "report-wrap",
      ref: "reportWrapRef",
      style: _normalizeStyle({ fontSize: _unref(emFt) })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, "提交时间：" + _toDisplayString(createAt.value), 1),
          _hoisted_5
        ])
      ]),
      _hoisted_6,
      _createElementVNode("ul", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.list, (item, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", null, _toDisplayString(item.title), 1)
            ]),
            (item.type === 'list')
              ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.infoList, (infoItem, infoIndex) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: infoIndex,
                      class: _normalizeClass(infoItem.noPddingRight ? 'no-padding-right' : '')
                    }, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(infoItem.label) + ":", 1),
                      _createElementVNode("div", _hoisted_11, _toDisplayString(infoItem.value), 1)
                    ], 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (item.type === 'text')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(item.text), 1))
              : _createCommentVNode("", true),
            (item.type === 'img')
              ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.imgList, (imageUrl, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: index }, [
                      _createElementVNode("img", {
                        src: imageUrl,
                        alt: "",
                        onClick: ($event: any) => (_unref(checkImage)(imageUrl, item.imgList))
                      }, null, 8, _hoisted_14)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ], 4)
  ], 4))
}
}

})